import { render } from "./AdvancedOptions.vue?vue&type=template&id=2ad50df0&scoped=true&ts=true"
import script from "./AdvancedOptions.vue?vue&type=script&lang=ts"
export * from "./AdvancedOptions.vue?vue&type=script&lang=ts"

import "./AdvancedOptions.vue?vue&type=style&index=0&id=2ad50df0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad50df0"]])

export default __exports__